export default "__VITE_ASSET__becb602b__"